module.exports = __webpack_public_path__ + "static/media/UploadIcon.1896e23c.svg";